export default Buffer.from("A+BSQ29weXJpZ2h0IDE5OTAtMjAwOSBBZG9iZSBTeXN0ZW1zIEluY29ycG9yYXRlZC4KQWxsIHJpZ2h0cyByZXNlcnZlZC4KU2VlIC4vTElDRU5TReEMVW5pR0ItVVRGOC1IQhHigJSEVhEAg/9aMQADEO82sPdt7zEKCwHvOg4AAe8zG+8yAQAB7w2BWwkBAADvBIQEDGIG44CIB4RIAAGEUgIBhEYAAYRQsPdwAYREEAGEQA==", "base64")


//////////////////
// WEBPACK FOOTER
// ./src/components/vue-pdf/src/buffer-loader.js!./node_modules/pdfjs-dist/cmaps/UniGB-UTF8-V.bcmap
// module id = dWaJ
// module chunks = 0